"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

var _jsxFileName = "/Users/brettstevenson/Desktop/Folder/gatsby-plugin-workspace/gatsby-plugin-disqus/src/components/Disqus.jsx";

var Disqus = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(Disqus, _React$Component);

  function Disqus(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.shortname = typeof GATSBY_DISQUS_SHORTNAME !== "undefined" && GATSBY_DISQUS_SHORTNAME !== '' ? GATSBY_DISQUS_SHORTNAME : '';

    if (props.config) {
      _this.config = props.config;
    } else {
      _this.config = {
        identifier: props.identifier,
        url: props.url,
        title: props.title,
        language: props.language
      };
    }

    return _this;
  }

  var _proto = Disqus.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined' && window.document && this.shortname) {
      this.cleanInstance();
    }

    this.loadInstance();
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (this.props === nextProps) return false;
    return (0, _utils.shallowComparison)(this.props, nextProps);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.loadInstance();
  };

  _proto.loadInstance = function loadInstance() {
    if (typeof window !== 'undefined' && window.document && this.shortname) {
      var component = this;
      var config = this.config;

      window.disqus_config = function () {
        this.page.identifier = config.identifier;
        this.page.title = config.title;
        this.page.url = config.url;
        this.language = config.language;
      };

      (0, _utils.insertScript)("https://" + this.shortname + ".disqus.com/embed.js", 'disqus-embed-script', window.document.body);
    }
  };

  _proto.cleanInstance = function cleanInstance() {
    (0, _utils.removeScript)('disqus-embed-script', window.document.body);

    if (window && window.DISQUS) {
      window.DISQUS.reset();
    }

    try {
      delete window.DISQUS;
    } catch (error) {
      window.DISQUS = undefined;
    }

    var thread = window.document.getElementById('disqus_thread');

    if (thread) {
      while (thread.hasChildNodes()) {
        thread.removeChild(thread.firstChild);
      }
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        config = _this$props.config,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["config"]);
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      id: "disqus_thread"
    }, props, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 7
      }
    }));
  };

  return Disqus;
}(_react.default.Component);

exports.default = Disqus;
Disqus.propTypes = {
  config: _propTypes.default.shape({
    /*
     * Tells the Disqus service how to identify the current page. 
     * When the Disqus embed is loaded, the identifier is used to look up 
     * the correct thread. 
     */
    identifier: _propTypes.default.string,

    /*
     * Tells the Disqus service the title of the current page.
     * This is used when creating the thread on Disqus.
     */
    title: _propTypes.default.string,

    /*
     * Tells the Disqus service the URL of the current page.
     * This URL is used when a thread is created so that Disqus knows which
     * page a thread belongs to.
     * (If undefined, Disqus will use the global.location.href)
     */
    url: _propTypes.default.string,

    /*
     * Tells the Disqus service to override the default site language for the
     * current page.
     * This allows for dynamically loading the Disqus embed in different 
     * languages on a per-page basis.
     * (If undefined, Disqus will use the default site language)
     */
    language: _propTypes.default.string
  }),
  identifier: _propTypes.default.string,
  title: _propTypes.default.string,
  url: _propTypes.default.string,
  language: _propTypes.default.string
};